import script from "./PermissionsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionsModal.vue?vue&type=script&setup=true&lang=js"

import "./PermissionsModal.vue?vue&type=style&index=0&id=183344a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-183344a7"]])

export default __exports__